import { initialExhibitionDarkMode } from './exhibitionTheme';

// A route-independent curtain keeps the underlying reading page out of a
// spatial transition. It stays in the top layer until the destination paints.
let curtain = null;
let deadline = null;
export async function coverViewTransition() {
  if (curtain) return;
  const node = document.createElement('dialog');
  node.setAttribute('aria-label', 'Moving through Views');
  node.style.cssText = 'position:fixed;inset:0;margin:0;width:100vw;height:100dvh;max-width:none;max-height:none;border:0;padding:0;pointer-events:none;';
  node.style.background = initialExhibitionDarkMode() ? '#292623' : '#f5f3ee';
  document.body.appendChild(node);
  node.showModal();
  curtain = node;
  deadline = setTimeout(revealViewTransition, 12000);
  const reduced = matchMedia('(prefers-reduced-motion:reduce)').matches;
  await node.animate([{opacity:0},{opacity:1}], {duration:reduced ? 0 : 400, easing:'ease-in-out', fill:'forwards'}).finished;
}
export function revealViewTransition() {
  const node = curtain;
  if (!node) return Promise.resolve();
  curtain = null;
  clearTimeout(deadline);
  return new Promise(resolve => requestAnimationFrame(() => requestAnimationFrame(() => {
    const reduced = matchMedia('(prefers-reduced-motion:reduce)').matches;
    node.animate([{opacity:1},{opacity:0}], {duration:reduced ? 0 : 450, easing:'ease-out', fill:'forwards'}).finished.catch(() => {}).finally(() => { node.close(); node.remove(); resolve(); });
  })));
}
